export default "__VITE_ASSET__dt0z8Jwp__"